<template>
    <div>
        <popup v-model="isShowPopup" position="bottom" :class="{ isNormal: isNormalStyle }">
            <div class="share-pop-container" :class="{ isNormal: isNormalStyle }">
                <div class="share-pop_body">
                    <share-header :shareHeaderText="shareHeaderText" v-if="!isNormalStyle" :showTips="showTips" />
                    <share-icon-list
                        :bi-tj-data="biTjData"
                        :business="business"
                        :shareInfo="shareInfo"
                        :custormBitTjData="custormBitTjData"
                        :custormBitTjProp="custormBitTjProp"
                        @handleCopy="handleCopy"
                        @close="changePopupStatus"
                    />
                </div>
                <div class="share-pop_footer" @click="isShowPopup = false">取消</div>
            </div>
        </popup>

        <copy-panel v-transferDom ref="copyPanel" :materialText="materialText" class="copy-panel-container" />
    </div>
</template>

<script>
import shareHeader from './components/shareHeader';
import shareIconList from './components/shareIconList';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import CopyPanel from 'root/topic/views/cardShare/components/ShareCtrl/materialText';
import transferDom from 'root/blackcard/directives/transfer-dom';
import { gioEvariableTrackOfPrivilege } from 'root/common/gio/tqGio';
import loginState from 'root/common/util/getLoginState.js';

import { getShareIcon, getShareInfo } from 'root/topic/views/shareFlowPage/api';
import { ready } from 'root/common/nativeApi';
import { getUtmParams } from '@/common/gio/utm';

const BIG_TJ_LOG_MAP = {
    gas: 'oil_station_list',
    ticket: 'ticket_detail',
    recharge: 'recharge_detail',
    kfc: 'kfc_address_list',
    supermarket: 'supermarket_list',
    main: 'guoqing_promo_page',
};

export default {
    components: { Popup, shareHeader, shareIconList, CopyPanel },
    directives: {
        transferDom,
    },
    props: {
        business: String, // recharge=充值,ticket=卡券,groupon=周边,gas=加油,kfc=炸鸡,movie=电影票,supermarket=商超
        redirectUrl: String,
        biTjData: {
            type: Object,
            default() {
                return {};
            },
        },
        isDontShowShareBtn: {
            type: Boolean,
            default: false,
        },
        isNormalStyle: {
            type: Boolean,
            default: false,
        },
        isAutoGetShareInfo: {
            type: Boolean,
            default: true,
        },
        showTips: {
            type: Boolean,
            default: true,
        },

        custormBitTjData: Object,
        custormBitTjProp: String,
    },
    data() {
        return {
            isShowPopup: false,
            isAPP: window.__is_blackApp,
            shareIcon: '',
            activity: '',
            shareHeaderText: {},
            materialText: '',

            shareInfo: {
                posterImgList: [],
                longUrl: '',
                shortUrl: '',
                wxTitle: '',
                wxIcon: '',
                copyText: '',
            },
        };
    },
    watch: {
        isShowPopup: {
            handler(newState) {
                if (newState) {
                    window.bigTj &&
                        window.bigTj.track('show', {
                            obj_id: 'share',
                            obj_type: BIG_TJ_LOG_MAP[this.business],
                            ...this.biTjData,
                        });

                    gioEvariableTrackOfPrivilege('shareClick', {
                        data: {
                            productType_var: '',
                            productName_var: '',
                            productId_var: '',
                            ...getUtmParams(window.location.hash),
                        },
                    });
                }
            },
            immediate: true,
        },
        isDontShowShareBtn(val) {
            if (val) {
                window.zzc &&
                    window.zzc.call('base_navbarRightButtons', {
                        items: [],
                    });
            } else {
                this.generateNativeBtn();
            }
        },
    },
    async mounted() {
        if (window.appIsTiShen) return;
        await ready();
        // 鸿蒙app不显示分享
        if (loginState() && this.isAPP && !this.isDontShowShareBtn) {
            await this.getShareIcon();
            this.generateNativeBtn();
        }

        if (this.isAutoGetShareInfo) {
            await this.getShareInfo();
        }
    },
    methods: {
        handleCopy(copyText) {
            if (typeof copyText == 'string') {
                this.materialText = [{ text: copyText }];
            } else {
                this.materialText = copyText.map(i => {
                    return {
                        text: i,
                    };
                });
            }

            this.isShowPopup = false;
            this.$refs.copyPanel.show();
        },
        changePopupStatus() {
            this.isShowPopup = !this.isShowPopup;
        },
        async getShareIcon() {
            // name: 'share-icon'
            const { code, data } = await getShareIcon({
                business: this.business,
            });
            if (code == 0) {
                if (data.img) {
                    this.shareIcon = data.img;
                    this.$emit('init-share-icon', this.shareIcon);
                } else {
                    this.isDontShowShareBtn = true;
                    this.$emit('closeIcon');
                }
                this.activity = data.activity;
            }
        },
        async getShareInfo() {
            const params = {
                activity: this.activity || 'top',
                business: this.business,
                redirectUrl: this.redirectUrl || location.href,
            };
            const { code, data } = await getShareInfo(params);
            if (code == 0) {
                this.shareHeaderText = data.popup;
                this.shareInfo = {
                    posterImgList: data.posterBg,
                    longUrl: data.url,
                    shortUrl: data.shortUrl,
                    wxTitle: data.wxTitle,
                    wxIcon: data.wxIcon,
                    copyText: data.copyText,
                    wxDesc: data.wxDesc,
                };
            }
            this.$emit('inited');
        },
        onClickNavbarRight() {
            if (this.isDontShowShareBtn) return;
            this.isShowPopup = true;
            this.getShareInfo();

            window.bigTj &&
                window.bigTj.track('click', {
                    obj_id: this.business == 'main' ? 'top_share_promo_page' : 'share',
                    obj_type: this.custormBitTjProp || BIG_TJ_LOG_MAP[this.business],
                    location:
                        this.business == 'ticket' && !this.custormBitTjProp
                            ? this.custormBitTjData && this.custormBitTjData.location
                            : '',
                    item_id: '',
                    item_name: '',
                    item_sort: 1,
                    location_id: '',
                    location_sort: 1,
                    sa_card_id: '',
                    page_source_type: '',
                    ...this.biTjData,
                });

            // window.bigTj &&
            //     window.bigTj.track('click', {
            //         obj_id: 'share',
            //         obj_type: BIG_TJ_LOG_MAP[this.business],
            //         spu_name: this.spuName,
            //     });
        },
        async generateNativeBtn() {
            /* setTimeout解决安卓不显示的bug */
            const _this = this;
            // 不使用原生navbar的时候不调用原生插件
            if (window.location.search.toLowerCase().indexOf('topbar_remove') >= 0) {
                return;
            }
            await ready();
            window.zzc.call('base_navbarRightButtons', {
                items: [
                    {
                        icon: this.shareIcon,
                        // icon:
                        //     'https://h5-promo.black-unique.com/slime/images/b86197d2cc912c93f3e85f38533ae6a7.png',
                        imageW: '35',
                        imageH: '35',
                    },
                ],
                success() {
                    _this.$emit('generatedBtn');
                },
            });
            window.zzc.on('app:navbarRightButtonsClick', this.onClickNavbarRight);
        },
    },
};
</script>

<style lang="scss" scoped>
.van-popup {
    border-radius: 0.2rem 0.2rem 0 0;
    z-index: 3000 !important;

    &.isNormal {
        border-radius: 0;
    }
}

.share-pop-container {
    width: 100%;
    min-height: 2.54rem;
    position: relative;
    // margin-bottom: 0.3rem;
    margin-bottom: env(safe-area-inset-bottom);
    margin-bottom: constant(safe-area-inset-bottom);

    &.isNormal {
        background: #fff;
    }

    .share-pop_body {
        height: calc(100% - 1rem);
        padding-bottom: 1rem;
    }

    .share-pop_footer {
        width: 100%;
        height: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        border-top: 0.015rem solid #e6e4dd;
        font-weight: bold;
        font-size: 0.32rem;
        // padding-bottom: calc(env(safe-area-inset-bottom));
        // padding-bottom: calc(contant(safe-area-inset-bottom));
    }
}

.copy-panel-container {
    z-index: 2010;
}
</style>
